import { render, staticRenderFns } from "./DependencyTableTabs.vue?vue&type=template&id=6e27e321&scoped=true&"
import script from "./DependencyTableTabs.vue?vue&type=script&lang=js&"
export * from "./DependencyTableTabs.vue?vue&type=script&lang=js&"
import style0 from "./DependencyTableTabs.vue?vue&type=style&index=0&id=6e27e321&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27e321",
  null
  
)

export default component.exports